module.exports = __webpack_public_path__ + "static/media/ScatteredClouds03d03n.e4723318.png";